import { ActiveMarkup, FAGroupViewModel } from '@fora-monorepo/employer-my-pages-common/types';

export const getMarkupStartDateOpenToDate = (
  activeMarkup: ActiveMarkup | null,
  faGroups: FAGroupViewModel[]
): string | null => {
  if (!activeMarkup) {
    return null;
  }
  const activeFaGroup = faGroups.find(faGroup => faGroup.fokId === activeMarkup.fokId);

  if (activeFaGroup?.validTo) {
    const initDate = new Date(activeFaGroup?.validTo);
    initDate.setDate(initDate.getDate() + 1);
    return initDate.toISOString().split('T')[0];
  }

  return null;
};
